<template>
  <div class="w-full py-5 min-h-[calc(100vh-64px)] bg-gray-50">
    <div>
      <h1 class="text-xl px-6 font-medium text-secondary [&>a]:no-underline [&>a]:text-secondary cursor-pointer"><a @click="navigate"><u>{{ headerDisplayValue }}</u></a> / Indberet</h1>
    </div>
    <section class="dynamic">
      <component v-for="componentName in reportCreateComponents" :is="componentName" :key="componentName"></component>
    </section>
  </div>
</template>

<script lang='ts'>
import { computed, defineComponent, ref, watch } from 'vue'
import RemarkSection from '@/components/report/remark-section.vue'
import SaveReportButton from '@/components/report/save-report-button.vue'
import DateSelector from '@/components/common/date-selector.vue'
import TimeIntervalSelector from '@/components/common/time-interval-selector.vue'
import TransportTypeSelector from '@/components/report/transport-type-select.vue'
import DistanceKmInput from '@/components/report/distance-km-input.vue'
import DietSelection from '@/components/report/diet-selection.vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { ReportType } from '@/models/report.model'
import { getValidReportType } from '@/core/utils'

const componentMap: any = {
  DateSelector,
  TimeIntervalSelector,
  TransportTypeSelector,
  DistanceKmInput,
  RemarkSection,
  SaveReportButton,
  DietSelection
}

export default defineComponent({
  name: 'createReport',
  setup () {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const typeParam = route.params.type as string
    const type = getValidReportType(typeParam)

    const updateReportType = () => {
      if (type != null) {
        store.dispatch('report/setReportType', type)
      } else {
        router.push('/')
      }
    }
    watch(() => route.params.type, updateReportType, { immediate: true })

    const navigate = () => {
      switch (type) {
        case ReportType.TRANSPORT:
          router.push('/reports/week/transport')
          break
        case ReportType.TIME:
          router.push('/reports/week/time')
          break
        case ReportType.SICK:
          router.push('/reports/week/sick')
          break
        case ReportType.DIET:
          router.push('/reports')
          break
        default:
          return ''
      }
    }

    const headerDisplayValue = computed(() => {
      switch (type) {
        case ReportType.TRANSPORT:
          return 'Transport'
        case ReportType.TIME:
          return 'Timer'
        case ReportType.SICK:
          return 'Sygdom'
        case ReportType.DIET:
          return 'Diæt'
        default:
          return ''
      }
    })

    const reportCreateComponents = computed(() => {
      const componentNames = store.getters['report/reportCreateComponents']
      return componentNames.map((name: string) => {
        const component = componentMap[name]
        return component
      })
    })

    return { headerDisplayValue, reportCreateComponents, navigate }
  }
})
</script>
